<template>
  <div class="repeat">
    <precautions
      v-if="selectedStep === 0"
      :title="questionData.Name"
      :level="level"
      :unit="unit"
      :questionData="questionData"
    />

    <!-- start -->
    <div class="d-flex justify-content-center mt-3" v-if="selectedStep === 0">
      <a
        class="d-inline-block gept_main_bg4 text-white px-5 py-2 rounded-pill mx-auto pointer font-weight-bold"
        @click="start()"
      >
        START
      </a>
    </div>

    <!-- main -->
    <div v-if="selectedStep === 1" class="repeat_inner bg-white p-3 p-lg-4">
      <QuestionOrder
        :questionData="questionData"
        :ERS_arr="ERS_arr"
        :actionIdx="questionNumber"
      />

      <div class="d-flex w-100 flex-wrap" v-if="questionData">
        <!-- 題目 -->
        <div class="col-12 col-md-4 item-outer p-2 p-lg-3 active">
          <div
            class="border-1 border-4 h-100 rounded-lg item_border position-relative border_main3 pointer"
            :class="{
              border_main2: isCanActive && actionStep === 0,
              border_main6: actionStep > 0
            }"
          >
            <div class="p-2 p-md-4 w-100 card_item_top">
              <p
                class="font-weight-bold gept_main_color6 text-center"
                :class="{
                  gept_main_color4: isCanActive && actionStep === 0,
                  gept_main_color7: actionStep > 0
                }"
              >
                題目
              </p>
            </div>

            <div class="card_item_center p-2">
              <img
                v-if="!isCanActive && actionStep < 0"
                @click.prevent="audio_play()"
                src="@/assets/image/gept/robot01_off.png"
                class="mx-auto d-block w-100 h-100 object-contain"
              >
              <img
                v-if="isCanActive && actionStep === 0"
                @click.prevent="audio_stop()"
                src="@/assets/image/gept/robot01_on.png"
                class="mx-auto d-block w-100 h-100 object-contain"
              >
              <img
                v-if="actionStep > 0"
                src="@/assets/image/gept/robot01_finish.png"
                class="mx-auto d-block w-100 h-100 object-contain"
              >
            </div>

            <div class="card_item_bottom d-flex align-items-end">
              <div
                class="p-4 text-center d-flex justify-content-center align-items-center w-100"
                v-if="!isCanActive && actionStep < 0"
              >
                <p class="gept_main_color6 font-weight-bold">
                  點選後開始播放題目
                </p>
              </div>

              <div
                class="p-4 border-top border-4 border_main6 w-100 d-flex justify-content-center align-items-center"
                v-if="actionStep > 0"
              >
                <p class="gept_main_color7 font-weight-bold text-center">
                  播放完畢
                </p>
              </div>

              <!-- tip off -->
              <div
                class="position-relative w-100 d-flex align-items-center"
                v-if="!isShowTitle && actionStep === 0"
              >
                <div
                  class="tips gept_main_bg5 p-3 h-100 rounded pointer"
                  @click="isShowTitle = true"
                >
                  <img src="@/assets/image/gept/icon_light.png" class="object-contain">
                </div>
                <div class="flex-1 d-flex align-items-center p-2 justify-content-center">
                  <p class="gept_main_color font-weight-bold text-center">
                    請仔細聆聽
                  </p>
                </div>
              </div>

              <!-- tip on -->
              <div
                class="d-flex w-100 border-top border-4 border_main2 align-items-center"
                v-if="isShowTitle && actionStep === 0"
              >
                <div
                  class="gept_main_bg5 p-3 py-4 h-100 pointer"
                  @click="isShowTitle = false"
                >
                  <img src="@/assets/image/gept/icon_close.png" class="object-contain">
                </div>
                <div class="flex-1 d-flex align-items-center p-2">
                  <p>{{ questionData.Questions[questionNumber].Title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 回答 -->
        <div class="col-12 col-md-4 item-outer p-2 p-lg-3">
          <div
            class="border-1 border-4 h-100 rounded-lg item_border item_border_arrow position-relative border_main3 pointer"
            :class="{
              border_main2: isCanActive && actionStep === 1,
              item_border_arrow_active: isCanActive && actionStep === 1,
              border_main6: actionStep > 1
            }"
          >
            <div
              class="position-absolute top-0 right-0 px-4 py-3 gept_main_bg5 text-white rounded-bottom-left font-weight-bold"
              v-if="actionStep === 1"
            >
              {{ answer_count }} s
            </div>

            <div class="card_item_top p-2 p-md-4 w-100">
              <p
                class="font-weight-bold gept_main_color6 text-center"
                :class="{
                  gept_main_color4: isCanActive && actionStep === 1,
                  gept_main_color7: isCanActive && actionStep > 1
                }"
              >
                回答
              </p>
            </div>

            <div class="card_item_center p-2 d-flex justify-content-center">
              <Recognition
                :showStage="showStage"
                @emitAudioData="emitAudioData"
                ref="recognition"
              />
            </div>

            <div
              class="card_item_bottom p-4 w-100 d-flex align-items-center justify-content-center border-top border-4 border_main3"
              :class="{ 'border_main6 gept_main_color7': !isCanActive && actionStep > 1 }"
            >
              <p class="font-weight-bold text-center gept_main_color6" v-if="actionStep < 1">
                問題播完後，<br>
                麥克風將會開啟錄音，<br>
                請在時間內回答完成。
              </p>
              <p class="font-weight-bold text-center" v-if="actionStep === 1">
                請回答問題
              </p>
              <p class="font-weight-bold text-center" v-if="actionStep > 1">
                錄音完畢
              </p>
            </div>
          </div>
        </div>

        <!-- 確認 -->
        <div class="col-12 col-md-4 item-outer p-2 p-lg-3">
          <div
            class="border-1 border-4 h-100 rounded-lg item_border item_border_arrow position-relative border_main3 pointer"
            :class="{ 'border_main2 item_border_arrow_active': actionStep > 1 }"
          >
            <div class="card_item_top p-2 p-md-4 w-100">
              <p class="font-weight-bold gept_main_color6 text-center" v-if="actionStep < 2">
                確認錄製
              </p>
              <p class="font-weight-bold gept_main_color4 text-center" v-if="actionStep === 2">
                錄製成功
              </p>
            </div>

            <div class="card_item_center p-2 position-relative">
              <img src="@/assets/image/gept/check_circle0.png" class="mx-auto d-block object-contain" v-if="actionStep < 2">
              <img src="@/assets/image/gept/check_circle1.png" class="mx-auto d-block object-contain" v-if="actionStep === 2">

              <UserVoice
                class="p-2 play-voice position-absolute"
                v-if="ERS_arr[questionNumber]?.audio"
                :ttsUrl="ERS_arr[questionNumber].audio"
              />
            </div>
            <div class="card_item_bottom p-4 w-100 item_text d-flex align-items-center justify-content-center border_main3 border-t-4"
              :class="{ 'border-white': ERS_arr[questionNumber] }">
              <div v-if="!ERS_arr[questionNumber]">
                <p class="gept_main_color6 text-lg text-center font-bold">確認已錄製，<br/>前往下一題。</p>
              </div>
              <div v-if="ERS_arr[questionNumber] && ERS_arr.length !== questionData.Questions.length" >
                <a class="d-inline-block gept_main_bg5 text-white px-3 px-5 py-2 rounded mx-3 pointer font-bold whitespace-no-wrap"
                  @click="nextQuestion()">
                  下一題
                </a>
              </div>
              <div v-if="ERS_arr.length === questionData.Questions.length">
                <a @click="toggleReport()" class="btn-default gept_main_bg5 text-white m-2 d-inline-block pointer">{{ !isLastGroup && $route.name === 'formal_exam' ? '前往下一個題型' : '交卷看報告' }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import api from '@/store/api'
  import precautions from '@/components/AiHelper/GEPT/precautions'
  import QuestionOrder from '@/components/AiHelper/GEPT/questionOrder'
  import Recognition from '@/components/AiHelper/GEPT/Recognition'
  import UserVoice from '@/components/AiHelper/GEPT/UserVoice'
  import allJs from '@/components/AiHelper/all.js'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  export default {
    name: 'repeat',

    data () {
      return {
        isShowTitle: false,

        selectedStep: 0,
        questionNumber: 0, //第幾題

        actionStep: -1, // 題目0 回答1 確認錄製2
        isCanActive: false, // 可以動作
        showStage: 0, // 錄音顯示步驟

        sound_effect: null,

        timer: null,

        // 回答
        answer_count: 15,

        ERS_arr: []
      }
    },
    mixins: [
      allJs,
      formal_examJs
    ],
    props: {
      questionData: {
        type: Object
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      }
    },
    components: {
      precautions,
      QuestionOrder,
      Recognition,
      UserVoice
    },
    computed: {
      testData () {
        let self = this
        if (localStorage.getItem(self.$route.params.select_id) && JSON.parse(localStorage.getItem(self.$route.params.select_id)).repeat) {
          return JSON.parse(localStorage.getItem(self.$route.params.select_id)).repeat
        }
        return []
      }
    },
    mounted () {
      this.$emit('setIsStart', false)
    },
    methods: {
      // step1
      setAudio () {
        let self = this

        if (self.actionStep > -1) {
          self.sound_effect = new Audio(self.questionData.Questions[self.questionNumber].AudioUrl)
          self.answer_count = self.questionData.Questions[self.questionNumber].Interval ? self.questionData.Questions[self.questionNumber].Interval : 15
        }
      },

      audio_play () {
        let self = this

        self.actionStep = 0

        self.setAudio()
        self.isCanActive = true
        self.sound_effect ? self.sound_effect.play() : null

        self.sound_effect.addEventListener('ended', () => {
          self.audio_stop()
        })

      },

      audio_stop () {
        let self = this

        self.sound_effect.pause()
        self.sound_effect.currentTime = 0

        self.actionStep = 1

        self.showStage = 1

        self.countDown()
      },

      // step2
      countDown () {
        let self = this
        self.timer = setInterval(() => {
            self.answer_count--

            if (self.answer_count === 0) {
              clearInterval(self.timer)

              self.$refs.recognition.stopRecord()

              self.answer_count = self.$options.data().answer_count
              self.showStage = 2
            }
          }, 1000
        )
      },
      async emitAudioData (emitAudioData) {
        let self = this

        self.actionStep = 2
        self.showStage = 2

        clearInterval(self.timer)
        self.$data.answer_count = self.$options.data().answer_count

        let result

        if (self.$route.name === 'practice_speaking') {
          result = await self.post_records_by_AIETA(self.$route.params.select_id, self.questionData.Questions[self.questionNumber].Id, self.questionData.Name, self.questionData.Questions[self.questionNumber].Title, emitAudioData)
        } else {
          result = await self.post_gept_records_byFormal(self.$route.query.record_id, self.questionData.Questions[self.questionNumber].Id, self.questionData.Name, self.questionData.Questions[self.questionNumber].Title, emitAudioData)
        }

        if (result) {
          self.isCanActive = false
          self.showStage = 2
          self.ERS_arr.push(result)
        }
      },

      // step3
      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false

        if (self.ERS_arr.length === self.questionData.Questions.length) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.params.select_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam' && !self.isLastGroup) {
            self.$nextTick(() => {
              self.$emit('guideNextType')
            })
          } else if (self.$route.name === 'formal_exam' && self.isLastGroup) {
            self.post_gept_records_finish(self.$route.query.record_id)
          }
        }
      },

      nextQuestion () {
        let self = this
        self.questionNumber++
        self.isCanActive = false
        self.isShowTitle = false

        self.actionStep = -1

        self.showStage = 0

        self.setAudio()

        self.$nextTick(() => {
          self.audio_play()
        })
      },

      // finfish
      reStart () {
        Object.assign(this.$data, this.$options.data())
      },

      start () {
        this.selectedStep = 1
        this.$emit('setIsStart', true)
      }
    }
  }
</script>

<style lang="scss" scoped>
.card_item_center {
  height: 320px;
}
.card_item_bottom {
  min-height: 150px;
}
.repeat {
  .repeat_inner {
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }
    .play-voice {
      right: 10%;
      bottom: 10%;
      z-index: 2;
      @media (max-width: 1024px) {
        right: 0%;
        bottom: 0%;
      }
      @media (max-width: 640px) {
        right: 10%;
        bottom: 10%;
      }
    }
    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    .item_text {
      min-height: 120px;
      height: 20%;
    }
  }
}
</style>
